export default __webpack_public_path__ + "static/media/pause.ea353bca.svg";